import { FC } from "react";
import { SplitFactory as SplitContext } from "@splitsoftware/splitio-react";
import { getVar } from "config";
import { ISplitFactoryProps } from "@splitsoftware/splitio-react/types/types";
import { getTreatments, initSplitSdk } from "@splitsoftware/splitio-redux";

export const FEATURES = ["event-recording-v2"] as const;

export type Features = typeof FEATURES[number];

export const splitIoConfig: SplitIO.IBrowserSettings = {
  core: {
    authorizationKey: getVar("REACT_APP_SPLIT_IO_API_KEY"),
    key: "remo",
  },
};

export const initSplitRedux = (isZoomEnabled = false) =>
  initSplitSdk({
    config: { ...splitIoConfig, streamingEnabled: isZoomEnabled },
  });

export const getSplitTreatments = (email: string) =>
  getTreatments({ splitNames: [...FEATURES], attributes: { email } });

export const SplitProvider: FC<Pick<ISplitFactoryProps, "children">> = ({
  children,
}) => <SplitContext config={splitIoConfig}>{children}</SplitContext>;
